module.exports = __webpack_public_path__ + "img/chr_ts_1_penlight.c2d14075.png";